import { ACCESS_DENIED, API_END, API_ERROR, API_START } from '../actions/types';

const initialState = {
  loading: {},
  error: null,
  accessDeniedFrom: null,
};

/**
 * `loading` is a map keyed by request label, not a single boolean. Two requests
 * in flight with one flag means the first to finish clears the spinner while
 * the second is still running.
 */
export default function api(state = initialState, action = {}) {
  switch (action.type) {
    case API_START:
      return { ...state, loading: { ...state.loading, [action.payload]: true } };

    case API_END: {
      const loading = { ...state.loading };
      delete loading[action.payload];

      return { ...state, loading };
    }

    case API_ERROR:
      return { ...state, error: action.error };

    case ACCESS_DENIED:
      return { ...state, accessDeniedFrom: action.payload.url };

    default:
      return state;
  }
}
